// Dependencies
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import Lazy from 'react-lazyload';

// Utils
import { Button, Heading } from '@nerdwallet/currency';
import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

// Components
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';

// Local Components
import ElementImpressionInteraction from '../../containers/element-impression-interaction';

// CSS
require('./goal-cta.less');

class GoalCta extends Component {
  renderCta(impressionId) {
    const { actionText, children, link, trackingId } = this.props;
    if (!actionText) {
      if (children) {
        return children;
      }

      return null;
    }

    return (
      <ElementImpressionInteraction
        id={impressionId}
        elementName={trackingId}
        type="CLICK"
      >
        <Button primary href={link} target="_blank">
          {actionText}
        </Button>
      </ElementImpressionInteraction>
    );
  }

  renderControls() {
    const { trackingId } = this.props;
    const impressionId = `mortgages-${trackingId}`;

    return (
      <div className="goal-cta-controls">
        <ElementImpression id={impressionId} elementName={trackingId}>
          {this.renderCta(impressionId)}
        </ElementImpression>
      </div>
    );
  }

  renderSubtitle() {
    const { subtitle } = this.props;
    if (!subtitle) {
      return null;
    }

    return <div className="goal-cta-subtitle">{subtitle}</div>;
  }

  renderTitle() {
    const { title } = this.props;
    if (!title) {
      return null;
    }

    return <Heading level="4">{title}</Heading>;
  }

  render() {
    const { imgUrl } = this.props;

    return (
      <div className="goal-cta">
        <div className="goal-cta-container">
          {this.renderTitle()}
          {this.renderSubtitle()}
          {this.renderControls()}
        </div>
        <Lazy>
          <img
            className="goal-cta-img"
            width="159"
            height="137"
            src={imgUrl}
            alt=""
          />
        </Lazy>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
GoalCta.propTypes = {
  actionText: PropTypes.string,
  children: PropTypes.node,
  imgUrl: PropTypes.string,
  link: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  trackingId: PropTypes.string,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
GoalCta.defaultProps = {
  actionText: null,
  children: null,
  imgUrl: iconUri('House_cloud'),
  trackingId: 'goal_cta',
  subtitle: null,
  title: null,
  link: null,
};

export default GoalCta;
